import { PromotionSchedule } from "./recurrence.types";
import { get12HourFormat } from "./recurrenceHelpers";

export function getPreview(schedule: PromotionSchedule): string {
  const { type, timeWindow, weekly, monthly } = schedule;

  const timeText = timeWindow?.[0]
    ? ` from ${get12HourFormat(timeWindow[0].startTime)} to ${get12HourFormat(
        timeWindow[0].endTime
      )}${timeWindow[0].overNight ? " (next day)" : ""}`
    : ""; 

  switch (type) {
    case "DAILY":
      return timeText ? `Runs every day${timeText}.` : `Runs every day.`;

    case "WEEKLY":
      if (!weekly || !weekly.daysOfWeek?.length) {
        return "Select weekdays.";
      }
      return timeText
        ? `Runs on ${weekly.daysOfWeek.join(", ")}${timeText}.`
        : `Runs on ${weekly.daysOfWeek.join(", ")}.`;

    case "MONTHLY":
      if (!monthly) return "";

      switch (monthly.option) {
        case "START_OF_MONTH":
          return timeText
            ? `Runs on the 1st of every month${timeText}.`
            : `Runs on the 1st of every month.`;

        case "SPECIFIC_DATES":
          if (!monthly.dates?.length) return "Select dates.";
          return timeText
            ? `Runs on ${monthly.dates.join(", ")} of every month${timeText}.`
            : `Runs on ${monthly.dates.join(", ")} of every month.`;

        case "SPECIFIC_WEEKDAYS":
          const weekPos = monthly.weekDays?.weekPosition ?? [];
          const weekDays = monthly.weekDays?.daysOfWeek ?? [];

          if (!weekPos.length || !weekDays.length) {
            return "Select week position and weekdays.";
          }

          return timeText
            ? `Runs on ${weekPos.join(", ")} ${weekDays.join(
                ", "
              )} of every month${timeText}.`
            : `Runs on ${weekPos.join(", ")} ${weekDays.join(
                ", "
              )} of every month.`;

        default:
          return "";
      }

    default:
      return "";
  }
}
